<script setup lang="ts">
import { ref } from "vue";
import LegacyDataLookup from "../components/LegacyDataLookup.vue";

const entries = ref([0]);
const another = () => {
  entries.value.push(entries.value.length);
};
</script>

<template>
  <h1>Legacy Data</h1>
  <p>Betatest: <a href="/timeline">Timeline</a></p>
  <div v-for="id in entries" :key="id">
    <LegacyDataLookup />
  </div>
  <pn-button @click="another">Another</pn-button>
</template>
<style lang="scss" scoped>
div {
  border-bottom: 2px dashed lightgrey;
  margin-bottom: 5rem;
  margin-top: 2rem;
}
</style>
